// extracted by mini-css-extract-plugin
module.exports = {"container":"_6R1YBv7yanJgrZ2zDitlN"};